/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Kind_PurchaseInputs */

const vi_stocktake_kind_purchase = /** @type {(inputs: Stocktake_Kind_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chè mua`)
};

/**

* @param {Stocktake_Kind_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_kind_purchase = /** @type {((inputs?: Stocktake_Kind_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Kind_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_kind_purchase(inputs)
});